import DIRECTION_OFFSETS from '_data/puzzleDirections';

export default {
  name: 'puzzle-table',
  methods: {
    loopTableRow(line, callback) {
      let initialColumn = line * this.model.columns;
      const finalColumn = initialColumn + this.model.columns;
      while (initialColumn < finalColumn) {
        callback(initialColumn);
        initialColumn += 1;
      }
    },
    loopTableColumn(column, callback) {
      let initialRow = 0;
      const totalRows = this.model.rows;

      while (initialRow < totalRows) {
        const index = (initialRow * this.model.columns) + column;
        callback(index);
        initialRow += 1;
      }
    },
    loopTableDiagonal(startRow, startColumn, direction, callback) {
      let currentRow = startRow;
      let currentColumn = startColumn;
      const totalRows = this.model.rows;
      const totalColumns = this.model.columns;

      const offset = DIRECTION_OFFSETS[direction];
      const rowIncrement = offset.row;
      const columnIncrement = offset.col;

      const isRowInBounds = row => row >= 0 && row < totalRows;
      const isColumnInBounds = col => col >= 0 && col < totalColumns;

      while (isRowInBounds(currentRow) && isColumnInBounds(currentColumn)) {
        const index = (currentRow * totalColumns) + currentColumn;
        callback(index);
        currentRow += rowIncrement;
        currentColumn += columnIncrement;
      }
    },
  },
};
